/** @format */

import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import store from "./store";
// import "./index.css";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import "./index.css";
import { AwsRum } from 'aws-rum-web';
import { initReplay } from './sessionReplay';

// Session replay records what the user saw; CloudWatch RUM below keeps
// performance, errors, HTTP and traces. Started first because the recorder wraps
// fetch, XHR and console as it starts, and anything above it is a blind spot.
initReplay();

// CloudWatch RUM
try {
  const config = {
    sessionSampleRate: 1,
    identityPoolId: process.env.REACT_APP_RUM_IDENTITY_POOL_ID || '',
    endpoint: 'https://dataplane.rum.us-east-1.amazonaws.com',
    // No 'replay' telemetry: session replay is @jobtarget/browser-rum's job, and
    // two DOM recorders in one document both patch fetch, XHR and console.
    telemetries: [
      'performance',
      'errors',
      [
        'http',
        {
          // Without this a request is recorded but linked to nothing on the
          // backend, so the RUM console's Traces column stays empty.
          addXRayTraceIdHeader: true,
          recordAllRequests: true,
          // aws-rum-web matches the URL as the caller wrote it, so an
          // absolute-only pattern traces nothing for relative fetches.
          urlsToInclude: [/^\/(?!\/)/, /^https?:\/\/[^/?#]*\.jobtarget\.com([/:?#]|$)/],
          // The replay intake is a *.jobtarget.com host, so the include pattern
          // catches it: RUM would instrument the recorder's own uploads, one
          // billable event and one X-Ray segment per chunk.
          urlsToExclude: [/rum-replay-intake\.jobtarget\.com/],
        },
      ],
    ],
    allowCookies: true,
    enableXRay: true,
  };
  const awsRum = new AwsRum(
    process.env.REACT_APP_RUM_APP_MONITOR_ID || '',
    // The release, not a literal: '1.0.0' says nothing about which deploy is live.
    process.env.REACT_APP_APP_RELEASE || '',
    'us-east-1',
    config,
  );
  // Join the two: the replay SDK pins its session id onto the RUM session, so the
  // console's CloudWatch RUM deep links resolve.
  import('@jobtarget/browser-rum').then(({ registerCloudWatchRum }) =>
    registerCloudWatchRum(awsRum),
  );
} catch (error) {
  // Ignore errors during RUM initialization
}

ReactDOM.render(
  <Provider store={store}>
    <React.StrictMode>
      <Router>
        <div className="container my-1" id="jt-app">
          <div className="row">
            <div className="col-12">
              <div className="card border-0 w-100 h-100" id="jt-app-card">
                <App />
              </div>
            </div>
          </div>
        </div>
      </Router>
    </React.StrictMode>
  </Provider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
